/*
Akhila 11/19/2022 2700271704 Created new Component
Sohel 11/22/2022 2700271704 fixed search Table reset Issue
Akhila 11/25/2022 2700271704 table title name change
akhila 11/26/2022 2700271704 changed titles for code and description
Sohel  12/05/2022 2700271704 Added Edit Icon and border to code
akhila 11/26/2022 2700271704 changed titles for code and description
Raghu 12/05/2022 2700271704 changed titles for code and description
akhila 12/08/2022 2700271704 adding session storage for search items
Akhila 12/09/2022 2700271704 fixed session saerch issue
lalitha 12/09/2022 2700271704 Added Created Date column and payload
Rajesh 12/15/2022 2700271704 added role access
sai krishna  1/2/2023 2700271704 rename labels, table headers
Dilip  02/13/2023 2700271704 created by payload changes
Raghu 02/23/2023 2700271704 fixed new Ui changes
Raghu 02/28/2023 2700271704 fixed new ui alignments
Raghu 04/04/2023 2700271704 added add icon
Ravi 05/31/2023 2700271704 changed delete popup message
Akhila 06/08/2023 2699234404 created date change to date created field and column
*/
import React, {useState, useEffect, createRef} from 'react';
import {Grid, TablePagination, Button} from '@material-ui/core';
import {tableIcons} from '../../../../components/TableIcons';
import {defaultRows} from '../../../../constants/ReusableTablePagination';
import {httpPaginationDelete, httpPaginationPost} from '../../../../util/Rest';
import {useDispatch} from 'react-redux';
import DeleteTableRecordPopup from '../../../../util/DeleteTableRecordPopup';
import {useUpdateEffect} from 'react-use';
import {ErrorSnackbar} from '../../../../components/CustomSnackBar/index';
import {SuccessSnackbar} from '../../../../components/CustomSnackBar/index';
import GuiTable from '../../../../components/FormComponents/GuiTable';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import {makeStyles} from '@material-ui/core';
import {tablePageRows} from '../../../../constants/ReusableConstants';
import {useSelector} from 'react-redux';
import PageLoader from '../../../../components/PageLoader';
import {
  fetchAccountUpdateGroup,
  resetAddAccountGroup,
} from '../../../../redux/reducers/AccountUpdateGroup';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import moment from 'moment';
import {fetchCreatedByDropDownData} from '../../../../redux/reducers/ReportMaster';
import AddIcon from '@material-ui/icons/AddOutlined';

export default function TriggerAccountSearchTable({searchData, setSubmit, submit, setValue}) {
  const [arrayLast, setArrayLast] = useState(false);

  const [isDelete, setIsDelete] = useState(false);
  const [tstmsg, setToastMsg] = useState('');
  const [deleteData, setDeleteData] = useState({});
  const [deleteErrorMsg, setDeleteErrorMsg] = useState('');
  const [status, setStatus] = useState(false);
  const {successMsg, errorMsg, isLoading} = useSelector(({addTriggerGroup}) => addTriggerGroup);
  const tableRef = createRef();
  const dispatch = useDispatch();
  const {roleData} = useSelector(({role}) => role);
  const disable = roleData?.window?.['Account Update']?.['AUG'];
  const useStyles = makeStyles((theme) => ({
    'link': {
      color: '#320469 !important',
      borderBottom: '1px solid #000099',
    },
    ' & .MuiSvgIcon-root': {
      backgroundColor: '#320469 !important',
    },
  }));
  const classes1 = useStyles();

  const columns = [
    {
      title: 'Account Update Name',
      field: 'groupCode',
      render: (rowData) => (
        <span
          role="button"
          className={classes1.link}
          onClick={() => {
            dispatch(fetchAccountUpdateGroup(rowData?.triggerAccountUpdateGroupId));
            setValue(1);
          }}
        >
          {rowData?.groupCode ? rowData.groupCode.replace(/ /g, '\u00a0') : ""}
        </span>
      ),
    },
    {
      title: 'Account Update  Description',
      field: 'groupDescription',
      render: (rowData) => (
        <>
          <div>
            {rowData.groupDescription ? rowData.groupDescription.replace(/ /g, '\u00a0') : ""}
          </div>
        </>
      ),
    },
    {
      title: 'Created By',
      field: 'createdBy',
    },
    {
      title: 'Date Created',
      field: 'createdDate',
      render: (rowData) => {
        return rowData?.createdDate ? moment(rowData?.createdDate).format('MM/DD/YYYY') : '';
      },
    },
  ];
  useEffect(() => {
    if (tableRef?.current && submit) {
      Object.keys(searchData).length > 0 ? tableRef.current.onQueryChange() : '';
    }
  }, [submit]);
  const [rows, setRows] = useState(defaultRows);

  const handleDelete = (rowData) => {
    setDeleteData(rowData);
    setIsDelete(true);
  };

  const handleClose = () => {
    setIsDelete(false);
  };

  useEffect(() => {
    if (tstmsg || deleteErrorMsg) {
      setTimeout(() => {
        setToastMsg('');
        setDeleteErrorMsg('');
      }, 2500);
    }
  }, [tstmsg, deleteErrorMsg]);

  const handleSubmit = () => {
    httpPaginationDelete(
        `triggeraccount/delete/triggeraccountupdategroup/${deleteData?.triggerAccountUpdateGroupId}`,
    )
      .then((response) => {
        if (response?.status === 200 && response?.data?.status !== 400) {
          setToastMsg(response?.response);
          setIsDelete(false);
          setStatus(true);
        } else {
          setDeleteErrorMsg(response?.data?.message);
          setIsDelete(false);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useUpdateEffect(() => {
    if (status === true) {
      tableRef.current.onQueryChange();
      dispatch(fetchCreatedByDropDownData('accountupdate'));
      setStatus(false);
    }
  }, [status]);

  useEffect(() => {
    dispatch(resetAddAccountGroup());
  }, []);
  const searchSessionTriggerAccount = JSON.parse(sessionStorage.getItem('SearchTriggerAccount'));
  if (searchSessionTriggerAccount && !submit) {
    searchData = searchSessionTriggerAccount;
  }
  return (
    <>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleClose}
        title="Delete Account Update Group"
        value={`Are you sure you want to delete the ${deleteData?.groupCode?.replace(/ /g, '\u00a0')} Account Update Group?`}
        handleSubmit={handleSubmit}
      />
      <Grid item xs={12}>
        <div className="custom-table global-field-table custom-toolbar-icons custom-actions-icon new-standard-textfields">
          <GuiTable
            title={''}
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            data={(query) =>
              new Promise((resolve) => {
                const url = `triggeraccount/search/triggeraccountupdate/search`;

                const bodyObj = {
                  limit: query?.pageSize ? query?.pageSize : null,
                  groupCode: searchData?.groupCode ? searchData?.groupCode : '',
                  groupDescription: searchData?.description ? searchData?.description : '',
                  orderDirection: query?.orderDirection,
                  orderBy: query?.orderBy && query?.orderBy?.field ? query?.orderBy?.field : '',
                  search: query?.search ? query?.search : '',
                  createdBy: searchData?.createdBy?.userLoginName ?
                    searchData?.createdBy?.userLoginName :
                    '',
                  createdDate: searchData?.createdDate ?
                    moment(searchData?.createdDate).format('MM/DD/YYYY') :
                    '',
                  page: submit ?
                    1 :
                    arrayLast && query?.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                };
                if (!searchData) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 0,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      if (response?.status === 200) {
                        const data = response.data.response.resultObjects;

                        resolve({
                          data: data.length > 0 ? data : [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setArrayLast(data.length === 1);
                        setSubmit(false);
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            options={{
              search: false,
              pageSize: rows,
              toolbar: true,
              toolbarButtonAlignment: 'left',
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer">
                  <TablePagination
                    {...props}
                    SelectProps={{
                      inputProps: {'aria-label': 'Rows per screen'},
                    }}
                    labelRowsPerPage={'Rows per screen:'}
                    rowsPerPageOptions={tablePageRows}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              ),
            }}
            actions={[
              {
                icon: () => <EditOutlinedIcon />,
                tooltip: 'Edit',
                disabled: !disable?.edit,
                onClick: (event, rowData) => {
                  dispatch(fetchAccountUpdateGroup(rowData?.triggerAccountUpdateGroupId));
                  setValue(1);
                },
              },
              (rowData) => {
                return {
                  icon: () => (
                    <>
                      <DeleteOutlineOutlinedIcon />
                    </>
                  ),
                  tooltip: 'Delete',
                  disabled: !disable?.delete,
                  onClick: () => {
                    handleDelete(rowData);
                  },
                };
              },
              {
                icon: () => (
                  <>
                    <div className="mb-1 new-standard-textfields">
                      <Button
                        type="button"
                        variant="outlined"
                        className={`search-btn`}
                        disabled={!disable?.add}
                        startIcon={<AddIcon />}
                      >
                        Add Account Update
                      </Button>
                    </div>
                  </>
                ),
                disabled: !disable?.add,
                isFreeAction: true,
                onClick: () => setValue(1),
              },
            ]}
          />
        </div>
      </Grid>
      {isLoading && <PageLoader />}
      {(deleteErrorMsg || errorMsg) && <ErrorSnackbar errorMsg={deleteErrorMsg || errorMsg} />}
      {(tstmsg || successMsg) && <SuccessSnackbar successMsg={tstmsg || successMsg} />}
    </>
  );
}
